import axios from "axios";
import querystring from "querystring";
import { getUserData, configFetch } from "./config"; // Mengimpor getUserData dan configFetch dari config.js

const HOSTNAME = process.env.REACT_APP_API_URL || "http://localhost:8080";

const API_SERVICES = {
  RoomTypeIndex: `${HOSTNAME}/roomtype/index`, // Endpoint untuk mendapatkan semua Room Types
  RoomTypeAdd: `${HOSTNAME}/roomtype/addroomtype`, // Endpoint untuk menambah Room Type
  RoomTypeUpdate: `${HOSTNAME}/roomtype/updateroomtype`, // Endpoint untuk update Room Type
  RoomTypeDelete: `${HOSTNAME}/roomtype/delete`, // Endpoint untuk delete Room Type
};

// Function to fetch room types
export const fetchRoomTypes = async () => {
  try {
    const userData = getUserData();

    const response = await axios(
      configFetch(API_SERVICES.RoomTypeIndex, "get", null, true, {
        Authorization: `Bearer ${userData.token}`,
      })
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching room types:", error.message);
    throw error;
  }
};

// Function to add a room type
export const addRoomType = async (data) => {
  try {
    const userData = getUserData();

    const currentDate = new Date().toISOString().split("T")[0];
    // Menambahkan id_user dan field lain yang diperlukan
    const payload = {
      ...data,
      id_company: 16,
      id_branch: 56,
      id_user: userData.userId,
      tgl_data: currentDate,
      tgl_valid: currentDate,
    };

    const response = await axios(
      configFetch(API_SERVICES.RoomTypeAdd, "post", payload, true, {
        Authorization: `Bearer ${userData.token}`,
      })
    );
    return response.data;
  } catch (error) {
    console.error("Error adding room type:", error.message);
    throw error;
  }
};

// Function to update a room type
export const updateRoomType = async (data) => {
  try {
    const userData = getUserData();
    const currentDate = new Date().toISOString().split("T")[0];
    // Menambahkan id_user dan field lain yang diperlukan
    const payload = {
      ...data,
      id_company: 16,
      id_branch: 56,
      id_user: userData.userId,
      tgl_data: currentDate,
      tgl_valid: currentDate,
    };

    const url = `${API_SERVICES.RoomTypeUpdate}`;
    const response = await axios(
      configFetch(url, "put", payload, true, {
        Authorization: `Bearer ${userData.token}`,
      })
    );
    return response.data;
  } catch (error) {
    console.error("Error updating room type:", error.message);
    throw error;
  }
};

// Function to delete a room type
export const deleteRoomType = async (id) => {
  try {
    const userData = getUserData();

    const url = `${API_SERVICES.RoomTypeDelete}`;
    await axios(
      configFetch(url, "delete", id, false, {
        Authorization: `Bearer ${userData.token}`,
      })
    );
  } catch (error) {
    console.error("Error deleting room type:", error.message);
    throw error;
  }
};
